import { useEffect, useState } from 'react'

import {
  faAngular,
  faDocker,
  faJava,
  faVuejs,
} from '@fortawesome/free-brands-svg-icons'
import { faMicrochip } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Loader from 'react-loaders'
import { Link } from 'react-router-dom'

import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = 'Touheed.'.split('')
  const jobArray = 'Staff Engineer'.split('')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <span className="hero-kicker">
            <span className="kicker-dot" />
            Available for new opportunities
          </span>
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>{' '}
            <span className="hero-name">
              <AnimatedLetters
                letterClass={letterClass}
                strArray={nameArray}
                idx={15}
              />
            </span>
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={23}
            />
          </h1>
          <div className="hero-chips">
            <span className="hero-chip">Java Full Stack</span>
            <span className="hero-chip">AI</span>
            <span className="hero-chip">Microservices</span>
            <span className="hero-chip">11+ Years</span>
          </div>
          <h2>
            Delivering IT solutions, building industry-grade applications and
            leading technical excellence.
          </h2>
          <div className="hero-actions">
            <Link to="/contact" className="flat-button primary">
              CONTACT ME
            </Link>
            <Link to="/projects" className="flat-button ghost">
              VIEW PROJECTS
            </Link>
          </div>
        </div>

        <div className="hero-visual" aria-hidden="true">
          <div className="glow-orb orb-1" />
          <div className="glow-orb orb-2" />

          <div className="code-window">
            <div className="window-bar">
              <span className="dot dot-red" />
              <span className="dot dot-yellow" />
              <span className="dot dot-green" />
              <span className="window-title">StaffEngineer.java</span>
            </div>
            <pre className="code-body">
              <span className="line">
                <span className="kw">public class</span>{' '}
                <span className="type">Touheed</span>{' '}
                <span className="kw">implements</span>{' '}
                <span className="type">StaffEngineer</span> {'{'}
              </span>
              <span className="line">
                {'  '}
                <span className="kw">private final</span>{' '}
                <span className="type">String</span>[] stack = {'{'}
              </span>
              <span className="line">
                {'    '}
                <span className="str">"Java"</span>,{' '}
                <span className="str">"Spring Boot"</span>,{' '}
                <span className="str">"AI"</span>,
              </span>
              <span className="line">
                {'    '}
                <span className="str">"Microservices"</span>,{' '}
                <span className="str">"Angular"</span>,{' '}
                <span className="str">"Vue"</span>
              </span>
              <span className="line">{'  };'}</span>
              <span className="line">&nbsp;</span>
              <span className="line">
                {'  '}
                <span className="type">Solution</span>{' '}
                <span className="fn">build</span>(
                <span className="type">Problem</span> p) {'{'}
              </span>
              <span className="line">
                {'    '}
                <span className="kw">return</span>{' '}
                <span className="fn">architect</span>(p).
                <span className="fn">withAI</span>().
                <span className="fn">ship</span>();
              </span>
              <span className="line">{'  }'}</span>
              <span className="line">
                {'}'}
                <span className="cursor" />
              </span>
            </pre>
          </div>

          <div className="float-badge badge-1">
            <FontAwesomeIcon icon={faJava} />
            <span>Java</span>
          </div>
          <div className="float-badge badge-2">
            <FontAwesomeIcon icon={faMicrochip} />
            <span>AI</span>
          </div>
          <div className="float-badge badge-3">
            <FontAwesomeIcon icon={faAngular} />
            <span>Angular</span>
          </div>
          <div className="float-badge badge-4">
            <FontAwesomeIcon icon={faVuejs} />
            <span>Vue</span>
          </div>
          <div className="float-badge badge-5">
            <FontAwesomeIcon icon={faDocker} />
            <span>Docker</span>
          </div>
        </div>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Home
